import { render, staticRenderFns } from "./FormMoveSale.vue?vue&type=template&id=198545cb"
import script from "./FormMoveSale.vue?vue&type=script&lang=js"
export * from "./FormMoveSale.vue?vue&type=script&lang=js"
import style0 from "./FormMoveSale.vue?vue&type=style&index=0&id=198545cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports